import { render, staticRenderFns } from "./LoadMoreButton.vue?vue&type=template&id=289cc3bf&scoped=true"
import script from "./LoadMoreButton.vue?vue&type=script&lang=js"
export * from "./LoadMoreButton.vue?vue&type=script&lang=js"
import style0 from "./LoadMoreButton.vue?vue&type=style&index=0&id=289cc3bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289cc3bf",
  null
  
)

export default component.exports